import React, {useEffect, useState} from "react"
import AlbumTile from "./AlbumTile"

const AlbumGallery = ({albums}) => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (albums.length === 0) {
            setIsLoading(false);
            return;
        }

        let loadedCount = 0;
        albums.forEach((album) => {
            const img = new Image();
            img.src = album.url;
            img.onload = () => {
                loadedCount++;
                if (loadedCount === albums.length) {
                    setIsLoading(false);
                }
            };
            img.onerror = () => {
                loadedCount++;
                if (loadedCount === albums.length) {
                    setIsLoading(false);
                }
            };
        });
    }, [albums]);

    let yearAlbumDict = {}
    for (let i = 0; i < albums.length; i++) {
        let albumYear = new Date(albums[i].created).getFullYear()
        if (albumYear in yearAlbumDict) {
            yearAlbumDict[albumYear].push(albums[i])
        } else {
            yearAlbumDict[albumYear] = [albums[i]]
        }
    }

    return (
        <>
            {isLoading ? (<div className="loading">Loading albums...</div>) :
            (<div className="container container-album-gallery">
                {Object.keys(yearAlbumDict).reverse().map((year) => {
                        return (
                            <div key={year}>
                                <h1 className="album-year">{year}</h1>
                                <div className="album-gallery">
                                    {yearAlbumDict[year].map((album) => {
                                        return (
                                            <AlbumTile key={album.id} album={album} />
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
            </div>)
            }
        </>
        
                
    )
}

export default AlbumGallery